export default "__VITE_PUBLIC_ASSET__84452fb2__"